import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class ZhhSessionLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getZhhSessionLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.czechiaSessionLimit,
			"v1/gameplay/czechia-session-limit"
		);
	}

	isCzechiaGameplayBlockEnabled(): boolean {
		return this.configService.get((x) => x.common.responsibleGaming.isCzechiaGameplayBlockEnabled, false);
	}
}
